export default "__VITE_ASSET__21aa51d6__"